import React, { useState } from 'react';
import './Sidebar.css';

export default function Sidebar({ setVista, modo, setFiltro, onLogout, setSidebarOpen }) {
  const [listaFinalizadosAbierta, setListaFinalizadosAbierta] = useState(false);

  // 👇 función auxiliar para cambiar vista y cerrar sidebar
  const handleClick = (vista) => {
    setVista(vista);
    setSidebarOpen(false); // ✅ cierra automáticamente
  };

  return (
    <aside className={`sidebar ${modo}`}>
      <h3 className="sidebar-title">Carnicería</h3>
      
      <ul className="sidebar-menu">
        <li onClick={() => handleClick('dashboard')}>
          <i className="fas fa-home"></i> Dashboard
        </li>
        <li onClick={() => handleClick('pedidos')}>
          <i className="fas fa-shopping-cart"></i> Pedidos
        </li>
        <li onClick={() => handleClick('pagos')}>
          <i className="fas fa-credit-card"></i> Pagos
        </li>
        <li onClick={() => handleClick('clientes')}>
          <i className="fas fa-users"></i> Clientes
        </li>
        <li onClick={() => handleClick('herramientas')}>
          <i className="fas fa-cog"></i> Herramientas
        </li>

        {/* Nueva sección: pedidos finalizados */}
        <li>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: 'pointer' }}
            onClick={() => setListaFinalizadosAbierta(prev => !prev)}
          >
            <span>
               Pedidos finalizados
            </span>
            <i className={`fas ${listaFinalizadosAbierta ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
          </div>

          {listaFinalizadosAbierta && (
            <ul className="list-group mt-2">
              <li
                className="list-group-item"
                onClick={() => {
                  setVista('pedidosFinalizados');
                  setFiltro('completados');
                  setSidebarOpen(false); // ✅ también cierra aquí
                }}
              >
                 Ver lista
              </li>
            </ul>
          )}
        </li>
      </ul>

      <div className="sidebar-footer">
        <button className="btn-logout" onClick={onLogout}>
          <i className="fas fa-sign-out-alt"></i> Cerrar sesión
        </button>
      </div>
    </aside>
  );
}
